<template>
    <div class="sign-in">
        <div class="sign-in__left">
            <img width="auto" height="33" :src="defaultLogoSrc" alt="MyCamper" />
            <span class="sign-in__rent-note">{{ $t('modals.login.rent_note') }}</span>
        </div>
        <div class="sign-in__right">
            <template v-if="!signupSuccessful">
                <h2 v-if="!siteLaunched" class="sign-in__title">
                    {{ $t('modals.signup.heading_interest') }}
                </h2>
                <template v-else>
                    <h2 class="sign-in__title">
                        <template v-if="!signupFormVisible">
                            {{ $t('modals.signup.heading') }}
                        </template>
                        <template v-else-if="formData.role === 'renter'">
                            {{ $t('modals.signup.renter_heading') }}
                        </template>
                        <template v-else-if="formData.role === 'owner'">
                            {{ $t('modals.signup.owner_heading') }}
                        </template>
                    </h2>
                </template>

                <SignUpForm
                    v-if="signupFormVisible"
                    :role="formData.role"
                    :email="formData.email"
                    :back-btn-visible="!role"
                    @back="signupFormVisible = false"
                    @signed-up="handleSignedUp"
                />
                <IntroSignUpForm v-else :type="type" @logged-in="handleLoggedIn" @email-not-found="openSignupForm" />

                <p class="sign-in__login-link">
                    {{ $t('modals.signup.already_signed_up') }}
                    <ModalLink to="login">
                        {{ $t('modals.signup.login_link') }}
                    </ModalLink>
                </p>
            </template>
            <template v-if="signupSuccessful">
                <h2 class="sign-in__title">
                    {{ $t('modals.signup.successful_heading') }}
                </h2>
                <p>
                    {{ $t('modals.signup.successful_text') }}
                </p>
                <p>
                    <ModalLink to="login">
                        {{ $t('modals.signup.login_link') }}
                    </ModalLink>
                </p>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { actionTypes as userActions } from '~/store/user';
import SignUpForm from '~/components/onboarding/SignUpForm.vue';
import IntroSignUpForm from '~/components/onboarding/IntroSignUpForm.vue';
import ModalLink from '~/components/modals/ModalLink.vue';

import defaultLogoSrc from '~/assets/images/mycamper-logo-with-text.svg';

export default {
    components: {
        SignUpForm,
        IntroSignUpForm,
        ModalLink,
    },
    props: {
        data: {
            type: Object,
            default: null,
        },
        type: {
            type: String,
            default: 'modal',
        },
    },
    data() {
        return {
            signupSuccessful: false,
            formData: {
                role: this.data?.role,
                email: this.data?.email,
            },
            signupFormVisible: false,
            defaultLogoSrc,
        };
    },
    computed: {
        ...mapGetters(['favoredAsset']),
        siteLaunched() {
            return this.featureEnabled('renterAccess') || this.featureEnabled('ownerAccess');
        },
        role() {
            if (this.data && this.data.role) {
                return this.data.role;
            }

            return null;
        },
        checkEmailBtnDisabled() {
            return this.$v.formData.email.$invalid || this.$v.formData.role.$invalid;
        },
    },
    created() {
        this.signupFormVisible = !!this.formData.role;
    },
    methods: {
        addPreviouslyFavoredAssetToFavorites() {
            if (this.favoredAsset) {
                this.$meService.addAssetToFavorites(this.favoredAsset);
                this.$store.dispatch(userActions.CLEAR_FAVORED_ASSET);
            }
        },
        openSignupForm(formData) {
            this.formData = formData;
            this.signupFormVisible = true;
        },
        handleSignedUp(response) {
            if (typeof response === 'object' && response.email) {
                // Was a user object returned? This means the user has already been logged in automatically
                if (this.favoredAsset) {
                    return this.$emit('confirmed');
                }

                this.$router.replace(this.localePath({ name: 'getting-started' }));

                this.$emit('confirmed');
            } else {
                // Display info about successful signup
                this.signupSuccessful = true;
            }

            this.addPreviouslyFavoredAssetToFavorites();
        },
        handleLoggedIn() {
            this.addPreviouslyFavoredAssetToFavorites();
        },
    },
};
</script>

<style lang="scss">
@import '@/sass/blocks/_sign-in.scss';
</style>
